import { Route, Routes } from '@angular/router';
import { OktaCallbackComponent } from '@okta/okta-angular';
import { CoreAuthComponent } from '../auth/auth.component';
import { LoginComponent } from '../login/login.component';

export const authRoutes: Route =
  {
    path: 'login',
    component: CoreAuthComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'okta'
      },
      {
        path: 'okta',
        component: LoginComponent,
      },
      {
        path: 'callback',
        component: OktaCallbackComponent
      }
    ]
  };
